import { useEffect } from 'react';
export const useCloseSelect = (dropdownRef, onClose) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                onClose();
            }
        };
        const handleFocusOut = (event) => {
            if (dropdownRef.current &&
                event.relatedTarget instanceof Node &&
                !dropdownRef.current.contains(event.relatedTarget)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        dropdownRef.current?.addEventListener('focusout', handleFocusOut);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            dropdownRef.current?.removeEventListener('focusout', handleFocusOut);
        };
    }, [dropdownRef, onClose]);
};
